module.exports = __webpack_public_path__ + "img/Sprogreformation_For_Arbeidsklassen.598d3df4.jpg";